const practice = {
  intro:
    "An engagement runs through five clear stages. Each stage has a written deliverable; each stage closes only when both sides sign that the deliverable is what was intended.",
  stages: [
    {
      key: "brief",
      n: "01",
      title: "Brief",
      body:
        "Every engagement opens with a written brief, co-authored with the operator — not from a template. The brief states the business problem, the existing systems in scope, the constraints, the non-negotiables and the working definition of done. Without this document we do not start; with it, the rest of the engagement is defensible.",
      output: "Engagement brief · written, signed, version-controlled",
    },
    {
      key: "design",
      n: "02",
      title: "Design",
      body:
        "We propose an architecture and a data model in writing, and defend them in a review with the operator's engineering and operations leads. The design is small enough to understand, durable enough to defend against changes that have not been imagined yet, and explicit about the trade-offs that have been taken.",
      output: "Architecture and data-model document · review-board approved",
    },
    {
      key: "build",
      n: "03",
      title: "Build",
      body:
        "Engineering proceeds in two-week increments. Each increment closes with a working demonstration to the operator and a written change-log. We work against the operator's repository and CI from day one — there is no hand-over moment, because the system has been in their environment the whole time.",
      output: "Two-week increments · production-grade code merged continuously",
    },
    {
      key: "handover",
      n: "04",
      title: "Hand-over",
      body:
        "Hand-over is a programme, not a moment. The system is documented, the on-call rotation is rehearsed with the operator's team, the runbook is written and the cost dashboard signed off by finance. We do not consider hand-over complete until the operator has run the system without our involvement for two cycles.",
      output: "Runbook · on-call rehearsal · finance-signed cost report",
    },
    {
      key: "support",
      n: "05",
      title: "Support",
      body:
        "After hand-over we offer two arrangements: a contracted retained backlog with a written SLA, or fixed-scope follow-up work we book in advance. Both are agreed before the build closes — never after — so the operator has cost certainty when they sign the year off.",
      output: "Retained backlog SLA or fixed-scope statement of work",
    },
  ],
};

export default practice;
